// "use client";
import React from "react";
import { Box, Button, Typography } from "../utils/mui-imports";
import { FaInstagram, FaFacebook, FaPinterest } from "react-icons/fa";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";

// Animation variants for the footer motion wrapper.
const sectionVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.6, ease: "easeOut" },
  },
};

const Footer = () => {
  const navigate = useNavigate();

  return (
    <motion.div
      variants={sectionVariants}
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      style={{ position: "relative", justifyContent: "center" }}
    >
      <Box
        sx={{
          backgroundImage: "url(abstractBG2.webp)",
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
          contentVisibility: "auto",
          contain: "layout style paint",
          backgroundColor: "black",
          width: "100%",
          // height: "auto",
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
        }}
      >
        <Box
          sx={{
            backdropFilter: "blur(5px)",
            backgroundColor: "rgba(0, 0, 0, 0.5)",
            height: "100%",
            py: 1,
            px: 4,
          }}
        >
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              flexDirection: "column",
              justifyContent: "space-between",
            }}
          >
            <a onClick={() => navigate("/")}>
              <img
                style={{ filter: "invert(1)" }}
                width={125}
                height={40}
                src="/logoNew.png"
                alt="StyleGenie"
              />
            </a>

            <Box sx={{ display: "flex", gap: 2 }}>
              <a
                onClick={() => window.open("https://www.instagram.com/styldrop", "_blank")}
                style={{ cursor: 'pointer' }}
              >
                <FaInstagram size={32} color="white" />
              </a>
              <a
              onClick={() => window.open("https://www.facebook.com/profile.php?id=61575164837873", "_blank")}
              style={{ cursor: 'pointer' }}
              >
                <FaFacebook size={32} color="white" />
              </a>
              <a
              onClick={() => window.open("https://www.pinterest.com/styldrop/", "_blank")}
              style={{ cursor: 'pointer' }}
              >
                <FaPinterest size={32} color="white" />
              </a>
            </Box>
          </Box>

          <Box
            sx={{
              position: "relative",
              bottom: 0,
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              alignItems: "center",
              pt: 2,
              px: 3,
              width: "100%",
            }}
          >
            <Box>
              <Typography fontSize="0.6rem" color="white">
                &copy; 2025 Buzzinspots
              </Typography>
            </Box>

            <Box sx={{ display: "flex", justifyContent: "right", gap: 1 }}>
              <Button
              onClick={()=>{navigate('/terms')}}
                variant="text"
                sx={{
                  fontWeight: "bold",
                  color: "white",
                  fontSize: "0.55rem",
                }}
              >
                Terms & Conditions
              </Button>

              <Button
              onClick={()=>{navigate('/privacy')}}
                variant="text"
                sx={{
                  fontWeight: "bold",
                  color: "white",
                  fontSize: "0.55rem",
                }}
              >
                Privacy Policy
              </Button>
            </Box>
          </Box>
        </Box>
      </Box>
    </motion.div>
  );
};

export default Footer;
